import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EmptyStateController from 'components/EmptyStateController';
import Button from 'components/Button';
import Flag from 'components/Flag';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Landmark from 'components/Landmark';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import PageTitle from 'components/PageTitle';
import LoadMoreOnScroll from 'components/LoadMoreOnScroll';
import { getCardTitleId, getCardDescriptionId } from 'components/ContentCards/shared';
import useAriaFeedProps from 'hooks/useAriaFeedProps';
import useBackLink from 'hooks/useBackLink';
import { useFetchBrowseTopics } from 'actions/topics';
import { useFetchMyBrowsePlaylists } from 'actions/playlists';
import SmartContentCard from '../../shared/smartContentCard';
import HelixOnlyAccessWrapper from '../home/HelixOnlyAccessWrapper';
import TopicList from './TopicList';
import Breadcrumbs from './breadcrumbs';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function BreadcrumbWidget(_ref) {
  var topic = _ref.topic,
    rootTitle = _ref.rootTitle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasParent = topic === null || topic === void 0 ? void 0 : topic.parent_id;
  var parentUrl = hasParent ? "/browse/".concat(topic.parent_id) : '/browse';
  var breadcrumbs = [{
    title: rootTitle,
    link: '/browse',
    key: 'root'
  }, hasParent && {
    title: topic.parent_name,
    link: parentUrl,
    key: topic.parent_id
  }, (topic === null || topic === void 0 ? void 0 : topic.id) && {
    title: topic.name,
    key: topic.id
  }].filter(Boolean);
  var backLink = useBackLink({
    fallback: parentUrl
  });
  return /*#__PURE__*/_jsx(Flag, {
    token: /*#__PURE__*/_jsx(Button, {
      round: true,
      as: NavLink,
      to: backLink,
      icon: "arrow",
      iconOnly: true,
      children: t('actions_back')
    }),
    children: /*#__PURE__*/_jsx(Breadcrumbs, {
      items: breadcrumbs
    })
  });
}
var PLAYLIST_HEADING_ID = 'playlist_heading';
function Browse() {
  var _useParams = useParams(),
    topicId = _useParams.topicId;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var isRoot = !topicId;

  // Make a request to get topics
  var _useFetchBrowseTopics = useFetchBrowseTopics({
      topicId: topicId
    }),
    _useFetchBrowseTopics2 = _useFetchBrowseTopics.data,
    data = _useFetchBrowseTopics2 === void 0 ? {
      subtopics: [],
      topic: null
    } : _useFetchBrowseTopics2;
  var subtopics = data.subtopics,
    topic = data.topic;
  var hasSubtopics = subtopics.length > 0;
  var _useFetchMyBrowsePlay = useFetchMyBrowsePlaylists({
      topic: topicId
    }),
    _useFetchMyBrowsePlay2 = _useFetchMyBrowsePlay.items,
    playlists = _useFetchMyBrowsePlay2 === void 0 ? [] : _useFetchMyBrowsePlay2,
    isLoading = _useFetchMyBrowsePlay.isLoading,
    isFetching = _useFetchMyBrowsePlay.isFetching,
    hasNextPage = _useFetchMyBrowsePlay.hasNextPage,
    isFetchingNextPage = _useFetchMyBrowsePlay.isFetchingNextPage,
    fetchNextPage = _useFetchMyBrowsePlay.fetchNextPage;
  var isLoadingMoreItems = isFetching && !isLoading;
  var _useAriaFeedProps = useAriaFeedProps({
      isLoading: isLoadingMoreItems
    }),
    getWrapperProps = _useAriaFeedProps.getWrapperProps,
    getItemProps = _useAriaFeedProps.getItemProps;
  var pageTitle = t('navbar_browse');
  var emptyContent = /*#__PURE__*/_jsx(Landmark, {
    id: "empty_state_browse_page",
    icon: "asset-image",
    children: /*#__PURE__*/_jsx("strong", {
      children: t('error_empty')
    })
  });
  var errorContent = /*#__PURE__*/_jsx(Landmark, {
    icon: "asset-image",
    children: /*#__PURE__*/_jsx("strong", {
      children: t('error_404')
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageSection, {
      children: isRoot ? /*#__PURE__*/_jsx(PageTitle, {
        size: "large",
        children: pageTitle
      }) : /*#__PURE__*/_jsx(BreadcrumbWidget, {
        topic: topic,
        rootTitle: pageTitle
      })
    }), hasSubtopics && /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "s",
        children: t('content_type_topic_plural')
      }), /*#__PURE__*/_jsx(TopicList, {
        items: subtopics
      })]
    }), /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "s",
        id: PLAYLIST_HEADING_ID,
        children: t('content_type_collections_and_playlists')
      }), /*#__PURE__*/_jsxs(EmptyStateController, {
        isEmpty: playlists.length === 0,
        emptyContent: emptyContent,
        errorContent: errorContent,
        isLoading: isLoading,
        children: [/*#__PURE__*/_jsx(CollectionGrid, _objectSpread(_objectSpread({}, getWrapperProps({
          labelledBy: PLAYLIST_HEADING_ID
        })), {}, {
          children: playlists.map(function (playlist, index) {
            var id = playlist.id;
            var titleId = getCardTitleId(id);
            var descriptionId = getCardDescriptionId(id);
            return /*#__PURE__*/_jsx(CollectionGridItem, _objectSpread(_objectSpread({
              id: "playlist_card_".concat(id)
            }, getItemProps({
              index: index,
              labelledBy: titleId,
              describedBy: descriptionId
            })), {}, {
              children: /*#__PURE__*/_jsx(SmartContentCard, {
                content: playlist,
                isFeedItem: true,
                useCustomId: true
              })
            }), playlist.id);
          })
        })), /*#__PURE__*/_jsx(LoadMoreOnScroll, {
          hasNextPage: hasNextPage,
          isFetchingNextPage: isFetchingNextPage,
          onFetchNextPage: fetchNextPage
        })]
      }), isLoadingMoreItems && /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      })]
    })]
  });
}
function ProtectedBrowse() {
  return /*#__PURE__*/_jsx(HelixOnlyAccessWrapper, {
    children: /*#__PURE__*/_jsx(Browse, {})
  });
}
export default ProtectedBrowse;